import { cn } from "@punchup/utils/cn";

interface ComedianNameProps {
  comedianName: string;
  size?: "sm" | "md" | "lg" | number;
  hide?: boolean;
  className?: string;
  handleComedianSelect?: (comedianName: string) => void;
}

export function ComedianName({
  comedianName,
  size = "sm",
  hide = false,
  className,
  handleComedianSelect,
}: ComedianNameProps) {
  if (hide) return null;

  const nameClass = size === "md" ? " text-[16px] md:text-lg" : "text-lg";

  return (
    <span
      className={cn(hide ? "hidden md:block" : "", className)}
      onClick={(e) => {
        e.stopPropagation();
        handleComedianSelect?.(comedianName);
      }}
    >
      <span
        className={cn("font-medium", nameClass)}
        style={{
          fontSize: typeof size === "number" ? size : undefined,
        }}
      >
        {comedianName}
      </span>
    </span>
  );
}
